import { CardsConfig, IconType, ItemPerRow, SelectMode } from '@rappider/rappider-components/utils';

export const ITEM_SELECTOR_CARDS_CONFIG: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Four,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 100,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Single,
        maxTagCount: 1
      },
      placeholder: 'Filter Tags',
      visibility: false
    },
    items: [],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search',
      },
      suffixIcon: {
        name: 'fas fa-search',
        type: IconType.FontAwesome,
      }
    }
  }
};
